import React, { Component } from "react";
import styles from "./styles";
import { actions } from "./actions";
import store from "./store";
import { Button, TextField, withStyles, Grid } from "@material-ui/core";
import Airport from './Airport'

class Filters extends Component {

  handleFNumChange = ({ target }) => {
  const value = target.value.toUpperCase();
  console.log("Flight number input:", value); // ✅ Check value here
  store.dispatch(actions.flightNumFilter(value));
};


  render() {
    const { classes } = this.props;

    return (
      <Grid container spacing={0}>
        <Airport type='Origin'/>
        <Airport type='Destination'/>
        <Grid item xs={12} md={4} className={classes.input}>
          <TextField
            label="Flight Number"
            variant="outlined"
            helperText="Filter by Flight Number"
            onChange={this.handleFNumChange}
            // onClick={this._onClick}
            margin="dense"
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(Filters);



// WEBPACK FOOTER //
// ./src/widgets/FlightStatus/Filters.js